import styled, { css, keyframes } from 'styled-components';

import { device } from '@/styles/helpers';

const fadeInOut = keyframes`
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

interface ScCopyCodeProps {
  copyActive: boolean;
  hoverColor?: string;
  noMarginBottom?: boolean;
  borderStyle?: string;
}

export const ScCopyCode = styled.div<ScCopyCodeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.03em;
  ${({ noMarginBottom }) =>
    !noMarginBottom &&
    css`
      margin-bottom: 24px;
    `}
  z-index: 2;
  position: relative;

  .copy-code {
    position: relative;
    flex: auto;
    min-width: 0;
    max-width: fit-content;

    & > p {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: ${({ borderStyle }) =>
        borderStyle === 'dotted' ? '22px' : '16px'};
      line-height: ${({ borderStyle }) =>
        borderStyle === 'dotted' ? '28px' : '20px'};
      letter-spacing: 0.44px;
      padding: ${({ borderStyle }) =>
        borderStyle === 'dotted' ? '8px 48px 8px 16px' : '4px 48px 8px 16px'};
      border-radius: ${({ borderStyle }) =>
        borderStyle === 'dotted' ? '360px' : '8px'};
      border: ${({ borderStyle }) => `2px ${borderStyle}`} #ea5b0c;
      height: ${({ borderStyle }) =>
        borderStyle === 'dotted' ? '40px' : '32px'};
    }

    &:before {
      content: attr(data-access);
      position: absolute;
      top: -25px;
      opacity: ${({ copyActive }) => (copyActive ? 1 : 0)};
      transition: opacity 0.2s;
      font-size: 14px;
      color: #fff;
      font-weight: 400;
      text-transform: none;
      text-align: center;
      left: 0;
      right: 0;
      pointer-events: none;
      z-index: 2;
      ${({ copyActive }) =>
        copyActive &&
        css`
          animation: ${fadeInOut} 1s forwards;
        `}
    }
  }

  & > button {
    margin-left: -40px;
    flex-shrink: 0;
    height: ${({ borderStyle }) =>
      borderStyle === 'dotted' ? '40px' : '32px'};
    border-radius: ${({ borderStyle }) =>
      borderStyle === 'dotted' ? '50px' : '8px'};
    min-width: ${({ borderStyle }) =>
      borderStyle === 'dotted' ? '50px' : '113px'};
    .awareWrap {
      border-radius: ${({ borderStyle }) =>
        borderStyle === 'dotted' ? '50px' : '8px'};
    }
  }

  @media (${device.mobileS}) {
    font-size: 16px;
    ${({ noMarginBottom }) =>
      !noMarginBottom &&
      css`
        margin-bottom: 10px;
      `}
    & > span {
      line-height: 38px;
    }
  }
`;
